import { useConfigContext } from "@/state/configContext";
import { formatMoney } from "@/helpers/helpers";
import { GET } from "@/state/api";
import { createFileRoute, Link, useRouter } from "@tanstack/react-router";
import { z } from "zod";

const SearchZod = z.object({ temporada_id: z.coerce.number() });
export const Route = createFileRoute("/admin/comisiones")({
  component: RouteComponent,
  validateSearch: SearchZod,
  loaderDeps: ({ search }) => ({ temporada_id: search.temporada_id }),
  loader: async (params) =>
    await GET("/admin/comisiones/:temporada_id", {
      p: params.location.search as z.infer<typeof SearchZod>,
    }),
});

function RouteComponent() {
  const { temporada_id } = Route.useSearch();
  const data = Route.useLoaderData();
  const config = useConfigContext();
  const router = useRouter();

  return (
    <div>
      <select
        value={temporada_id}
        onChange={(e) =>
          router.navigate({
            to: "/admin/comisiones",
            search: { temporada_id: Number(e.target.value) },
          })
        }
      >
        {Object.values(config.temporadas)
          .sort((a, b) => b.prioridad - a.prioridad)
          .map(({ id, nombre }) => (
            <option value={id} key={id}>
              {nombre}
            </option>
          ))}
      </select>
      <h1>{data.temporada.nombre}</h1>
      <div className="table-responsive">
        <table className="table table-striped table-hover comisiones">
          <thead>
            <tr>
              <th>Fotografo</th>
              <th>Fotos</th>
              <th>Facturado</th>
              <th>%</th>
              <th>Comisiones</th>
              <th>Premios</th>
              <th>Pagado</th>
              <th>Saldo</th>
            </tr>
          </thead>
          <tbody>
            {data.comisiones.map((c) => (
              <tr key={c.fotografo_id}>
                <td>
                  <Link
                    to="/admin/comisionesF"
                    search={{ temporada_id, fotografo_id: c.fotografo_id }}
                  >
                    {c.fotografo}
                  </Link>
                </td>
                {(
                  [
                    "fotosN",
                    "totalf",
                    "pc",
                    "comisiones",
                    "premios",
                    "pagado",
                    "saldo",
                  ] as const satisfies (keyof typeof c)[]
                ).map((k) => (
                  <td key={k}>
                    {" "}
                    {typeof c[k] === "number" ? formatMoney(c[k]) : c[k]}
                  </td>
                ))}
              </tr>
            ))}
            <tr>
              <th>Total</th>
              {(
                [
                  "fotosN",
                  "totalf",
                  null,
                  "comisiones",
                  "premios",
                  "pagado",
                  "saldo",
                ] satisfies (null | keyof (typeof data.comisiones)[number])[]
              ).map((k) => (
                <th key={k}>
                  {k &&
                    formatMoney(
                      data.comisiones
                        .map((x) => Number(x[k] || 0))
                        .reduce((a, b) => a + b, 0)
                    )}
                </th>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
